import { Col, Row } from "antd";
import { InputStyle, labelStyle } from "../constants";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import InputComponent from "../../../components/InputComponent";
import { useCDNFileContext } from "../../../context/CDNFileContext/CDNFileContext";


const CDNFileDetail = () => {
	const { cdnData, setCDNFileData } = useCDNFileContext();

	const handleFileChange = (fileData: FileData[] | null) => {
		setCDNFileData(prevState => ({
			...prevState,
			imageUrl: fileData?.[0]?.file || null
		}));
	};

	return (
		<>				
			<Row gutter={20}>
				<Col span={12}>
					<InputComponent
						title={"Başlık"}
						placeholder=""
						value={cdnData?.title}
						style={InputStyle}
						isRequired
						onChange={(e) => setCDNFileData({ ...cdnData, title: e.target.value })}
					/>
				</Col>
				<Col span={8}>
					<FileUploadComponent
						title="CDN Dosyasi"
						onChange={(fileData: FileData[] | null) => handleFileChange(fileData)}
						fileSize="5242880"
						fileSizeText="Max 5MB"
						format="image/jpeg,image/png,image/webp"
						defaultValue={cdnData.imageUrl as string | null}
					/>
				</Col>
			</Row>
		</>
	);
};

export default CDNFileDetail;
